/**
 * @author xiaohuangmaoth
 * @description 考试情况组织岗位统计
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

const _getValue = (type, key) => {
  const values = {
    examType: {
      '0': '独立考试',
      '1': '课程考试',
      '0,1': '独立考试、课程考试',
      '1,0': '独立考试、课程考试'
    },
  }
  return values[type][key] || ''
}

class OrgJobExaminationStatistics extends WizContainer {
  componentName = "OrgJobExaminationStatistics";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        examType: _getValue('examType', val.examType),
        passRate: val.passRate + '%',
        rate: val.rate + '%'
      }))

      const title = '考试情况组织岗位统计'
      
      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true
      
    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(OrgJobExaminationStatistics);
